export default {
    MainData: {
        'err_no': 0,
        'err_msg': 'success',
        'data': {
            'base': {
                'start_time': '1661097600',
                'end_time': '1662047999',
                'active_status': 1,
                'title': '百度地图打车9月放价',
                'sub_title': '百度地图打车9月放价',
                'desc': '百度地图打车9月放价',
                'is_login': 1,
                'click_login': '1',
                'rules': [
                    {
                        'title': '活动城市：全国'
                    },
                    {
                        'title': '活动时间：2022年9月1日00:00:00-2022年9月30日23:59:59'
                    },
                    {
                        'title': '一、优惠领取、购买',
                        'children': [
                            '1.\t五折秒杀：',
                            '\t\t秒杀开始时间：每天早上9点整、下午17点整；',
                            '\t\t秒杀方式：通过活动页面五折秒杀区点击『抢』即可参与，每场秒杀数量有限，先到先得，当场发完即止；',
                            '2.\t花样券包领取：',
                            '\t\t优惠券包发放方式：优惠券包以每周一至每周日为一个发放周期进行免费发放，活动期间发放包含通勤券、周末券、远途券、节日券等优惠种类，'
                            + '分别在对应的时间内进行开放领取，具体可见活动页中优惠一整月预告日历。',
                            '3.\t优惠套餐购买：活动期间将适时推出不同种类的付费套餐，包含券包、爱奇艺 VIP 混合礼包等，限时上架限时购买，可随时关注活动。'
                        ]
                    },
                    {
                        'title': '二、优惠使用规则',
                        'children': [
                            '1.\t秒杀五折卡使用规则：限线上订单使用，最高抵扣10元，自领取后7天内使用有效，出租车不可用，每笔订单仅可使用一张，具体使用规则见券面详情：',
                            '2.\t每个用户每个发放周期每种优惠券限领1张；通勤券领取后7天有效，限每周一至周五工作日早晚高峰时间段、部分车型使用（节假日除外），具体使用规则见券面详情；'
                            + '周末券领取后7天有效，限每周六、日7点-23点使用，具体使用规则见券面详情；节日券限节日时间内使用，具体使用规则见券面详情；',
                            '3.\t券包购买：具体使用时间及规则见券面详情。'
                        ]
                    },
                    {
                        'title': '三、统一说明',
                        'children': [
                            '\t打车券有效期见券面详情，用户需在券规定有效期内使用，若超期未用则视为放弃；查看优惠券方式：百度地图-打车页面-右上角-优惠。'
                        ]
                    },
                    {
                        'title': '四、活动特别声明：',
                        'children': [
                            '1.\t此活动需要升级至最新版本的百度地图',
                            '2.\t对于通过系统漏洞，虚假操作，黑客工具，作弊工具等非正当手段参与活动的用户，百度地图有权取消其参与活动和获奖的资格，冻结或撤销其已获得的奖品（包括已使用的和未使用的）',
                            '3.\t如出现不可抗力或情势变更的情况(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动遭受严重网络攻击或因系统故障办的)，百度地图有权取消、终止、'
                            + '修改或暂停活动',
                            '4.\t百度地图不会采用电话/短信联系方式通知中奖信息，如遇以本活动名义为由收取各种税金或者要求缴费等的电话或短信，请勿采信',
                            '5.\t活动期间，请您保持手机适网状态，如出现用户所在地区网络故障、支付平台网络不畅、电信运营商故障等非百度所能控制的原因，则可能导致您无法参与活动或参与失败',
                            '6.\t百度公司对本活动内容享有修订权，并可在法律规定范围内对活动规则进行解释',
                            '7.\t如您有任何疑问，可以通过如下方式与我们联系即活动咨询：'
                        ]
                    }
                ],
                'active_status_dialog': '1',
                'remind': '1',
                'token': 'c56497edc6e35c4d3a2e71e1f3ad6d17',
                'share': {
                    'wxTitle': '打车9月大放价！',
                    'wxText': '超值打车不只五折，更省出发，更快到达！',
                    'wxFriendText': '打车9月大放价！超值打车不只五折！',
                    'weiboText': '#打车9月大放价# 超值打车，不只五折，更省出发，更快到达！',
                    'wxPic': 'https://dache.cdn.bcebos.com/yy/activity/main/wx.png',
                    'wxBigPic': 'https://dache.cdn.bcebos.com/yy/activity/main/wx.png',
                    'weiboPic': 'https://dache.cdn.bcebos.com/yy/activity/main/wb.png'
                }
            },
            'bottom': {
                'url': '',
                'style': {
                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/bottom-logo.png',
                    'marginTop': 50,
                    'width': 207,
                    'height': 58
                }
            },
            'floatBtn': {
                'url': 'baidumap://map/component?popRoot=no&resetRoot=no&needLocation=yes&needCloud=yes&comName=rentcar&target=rentcar_entrance&mode=MAP_MODE&param=%7B%22src_from%22%3A%22OM-dacu%22%7D&pageType=new&pagePrefer=auto',
                'style': {
                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/float-btn.png',
                    'position': 'absolute',
                    'top': 314,
                    'right': 20,
                    'width': 202,
                    'height': 192
                }
            },
            'style': {
                'pageBg': {
                    'backgroundColor': '#F9A090'
                },
                'headerBg': {
                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/main-head.png',
                    'width': 750,
                    'height': 485
                },
                'modules': {
                    'top': -60
                },
                'ruleBg': {
                    'background': 'linear-gradient(180deg, #FD6B5C, #F45D4E)'
                },
                'remind': {
                    'bg': {
                        'background': 'linear-gradient(180deg, #FD6B5C, #F45D4E)',
                        'width': 480,
                        'height': 610,
                        'borderRadius': 18
                    },
                    'header': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/dialog/remind-header.png',
                        'width': 417,
                        'height': 331
                    },
                    'remindBtn': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/dialog/remind-btn.png',
                        'width': 288,
                        'height': 79
                    },
                    'leaveBtn': {
                        'fontSize': 30,
                        'color': '#fff',
                        'marginTop': 20
                    }
                },
                'activityStatusDialog': {
                    '0': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/dialog/activity-end.png',
                        'width': 480,
                        'height': 465
                    },
                    '9': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/dialog/activity-end.png',
                        'width': 480,
                        'height': 465
                    }
                }
            },
            'modules': [
                {
                    'active_type': 'package',
                    'style': {
                        'background': {
                            'marginTop': 0,
                            'width': 711
                        }
                    },
                    'title': '头图样式',
                    'list': [
                        {
                            'active_type': 'method',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m1-a9.1.png',
                                    'width': 711,
                                    'height': 194
                                },
                                'btn': {
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m1-b1.png',
                                        'bottom': 48,
                                        'right': 0,
                                        'width': 118,
                                        'height': 117
                                    },
                                    '2': {
                                        'bottom': 0,
                                        'right': 0,
                                        'width': 100,
                                        'height': 60
                                    }
                                }
                            },
                            'button': {
                                'name': 'show',
                                'status': '1',
                                'type': 'method',
                                'method': {
                                    'name': 'changeBgStyle',
                                    'params': {
                                        'status': 2
                                    },
                                    'style': {
                                        'background': {
                                            'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m1-b.png',
                                            'width': 711,
                                            'height': 815
                                        }
                                    }
                                }
                            }
                        }
                    ]
                },
                {
                    'active_type': 'package',
                    'style': {
                        'background': {
                            'marginTop': 36,
                            'width': 711,
                            'height': 183
                        }
                    },
                    'title': '秒杀',
                    'list': [
                        {
                            'active_type': 'seckill',
                            'count_down_time': 5,
                            'card_id': 'aaaaaaaa',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c3.png',
                                    'width': 711,
                                    'height': 183
                                },
                                'btn': {
                                    '0': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                                        'top': 20,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    },
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                                        'top': 18,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    },
                                    '4': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b3.png',
                                        'top': 18,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    },
                                    '2': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b2.png',
                                        'top': 18,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    },
                                    '5': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                                        'top': 18,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    },
                                    '3': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b2.png',
                                        'top': 18,
                                        'right': -4,
                                        'width': 176,
                                        'height': 176
                                    }
                                }
                            },
                            'button': {
                                'name': '进行中',
                                'status': 1,
                                'type': 'toast',
                                'toast': '还未开始',
                                'params': 'W10='
                            }
                        }
                    ]
                },
                {
                    'active_type': 'package',
                    'style': {
                        'background': {
                            'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-2.png',
                            'marginTop': 30,
                            'width': 711,
                            'height': 622
                        }
                    },
                    'title': '花样券包领不停',
                    'list': [
                        {
                            'active_type': 'coupon',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c62.png',
                                    'marginTop': 110,
                                    'width': 681,
                                    'height': 218
                                },
                                'btn': {
                                    '0': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b0.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b0.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '4': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b1.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '2': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b2.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '3': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b0.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    }
                                }
                            },
                            'button': {
                                'name': '进行中',
                                'status': 1,
                                'type': 'request',
                                'params': 'eyJtb2R1bGVfbmFtZSI6ImNvdXBvbjYzMDRjMzdkZDg1MWUiLCJxdCI6ImppdXl1ZWRhY3UifQ=='
                            }
                        },
                        {
                            'active_type': 'coupon',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c36.png',
                                    'marginTop': 10,
                                    'width': 681,
                                    'height': 218
                                },
                                'btn': {
                                    '0': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b2.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b0.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '4': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b1.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '2': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b2.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    },
                                    '3': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m3-c-b0.png',
                                        'top': 76,
                                        'right': 28,
                                        'width': 153,
                                        'height': 68
                                    }
                                }
                            },
                            'button': {
                                'name': '进行中',
                                'status': 0,
                                'type': 'request',
                                'params': 'W10='
                            }
                        }
                    ]
                },
                {
                    'active_type': 'package',
                    'style': {
                        'background': {
                            'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m4-2.png',
                            'marginTop': 30,
                            'width': 711,
                            'height': 573
                        }
                    },
                    'title': '超值套餐优惠购',
                    'list': [
                        {
                            'active_type': 'coupon',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m4-c9.1.png',
                                    'marginTop': 110,
                                    'width': 673,
                                    'height': 175
                                },
                                'btn': {
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m5-c1-b0.png',
                                        'top': 66,
                                        'right': 28,
                                        'width': 162,
                                        'height': 57
                                    }
                                }
                            },
                            'button': {
                                'name': '立即购买',
                                'status': 1,
                                'type': 'direct',
                                'url': 'https://yongche.baidu.com/vouchers.html?goods_id=81'
                            }
                        },
                        {
                            'active_type': 'coupon',
                            'style': {
                                'background': {
                                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m4-c4.99.png',
                                    'marginTop': 10,
                                    'width': 673,
                                    'height': 175
                                },
                                'btn': {
                                    '1': {
                                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m5-c1-b0.png',
                                        'top': 66,
                                        'right': 28,
                                        'width': 162,
                                        'height': 57
                                    }
                                }
                            },
                            'button': {
                                'name': '立即购买',
                                'status': 1,
                                'type': 'direct',
                                'url': 'https://yongche.baidu.com/vouchers.html?goods_id=68'
                            }
                        }
                    ]
                }
            ]
        }
    },
    GetCardDetail: {
        'err_no': 0,
        'err_msg': 'success',
        'data': {
            'active_type': 'seckill2',
            'count_down_time': 3,
            'card_id': 'aaaaaaaa',
            'style': {
                'background': {
                    'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c3.png',
                    'width': 711,
                    'height': 183
                },
                'btn': {
                    '0': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                        'top': 20,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    },
                    '1': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                        'top': 18,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    },
                    '4': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b3.png',
                        'top': 18,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    },
                    '2': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b2.png',
                        'top': 18,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    },
                    '5': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b1.png',
                        'top': 18,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    },
                    '3': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/m2-c-b2.png',
                        'top': 18,
                        'right': -4,
                        'width': 176,
                        'height': 176
                    }
                }
            },
            'button': {
                'name': '进行中',
                'status': 2,
                'type': 'request',
                'params': 'W10='
            }
        }
    },
    GetCard: {
        'err_no': 0,
        'err_msg': 'success',
        'data': {
            'name': '马上抢',
            'type': 'direct',
            'status': 4,
            'url': 'http://www.baidu.com',
            'response': {
                'type': 'dialog',
                'success': {
                    'style': {
                        'backgroundImage': 'https://dache.cdn.bcebos.com/yy/activity/main/dialog/get-success.png',
                        'width': 480,
                        'height': 618
                    },
                    'url': 'http://www.baidu.com'
                }
            }
        }
    }
};
